var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 568 546",
    style: {
      enableBackground: "new 0 0 568 546"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#007BBC;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#010B6C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284,546.8c-150.7,0-273.4-122.6-273.4-273.4C10.6,122.6,133.3,0,284,0c150.7,0,273.4,122.6,273.4,273.4 C557.4,424.1,434.7,546.8,284,546.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M438.6,294.2v102.1c0,2.5-2,4.6-4.6,4.6h-52.7c-2.5,0-4.6-2-4.6-4.6v-94.9c0-25-8.9-42-31.3-42 c-17.1,0-27.2,11.5-31.7,22.6c-1.6,4-2,9.5-2,15.1v99.3c0,2.5-2,4.6-4.6,4.6h-52.7c-2.5,0-4.6-2-4.6-4.6 c0.1-25.3,0.7-147.9,0.1-176.8c0-2.6,2-4.6,4.6-4.6h52.6c2.5,0,4.6,2,4.6,4.6v21.8c-0.1,0.2-0.3,0.4-0.4,0.6h0.4v-0.6 c8.2-12.6,22.9-30.7,55.7-30.7C408.1,210.5,438.6,237.1,438.6,294.2L438.6,294.2z M158.4,400.8h52.7c2.5,0,4.6-2,4.6-4.6V219.4 c0-2.5-2-4.6-4.6-4.6h-52.7c-2.5,0-4.6,2-4.6,4.6v176.8C153.8,398.8,155.9,400.8,158.4,400.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 182.9,
    cy: 158.1,
    r: 33.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin_00000155140906748536784780000002293479206396163515_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.9,1.1C132.8,1.1,10.6,123.2,10.6,273.4s122.1,272.3,272.3,272.3c150.1,0,272.3-122.2,272.3-272.3 S433.1,1.1,282.9,1.1z M214.8,395.8c0,2.5-2,4.5-4.5,4.5h-52.5c-2.5,0-4.5-2-4.5-4.5V219.6c0-2.5,2-4.5,4.5-4.5h52.5 c2.5,0,4.5,2,4.5,4.5V395.8z M182.2,191.5c-18.2,0-33-14.8-33-33c0-18.2,14.8-33,33-33c18.2,0,33,14.8,33,33 C215.2,176.8,200.4,191.5,182.2,191.5z M436.9,395.8c0,2.5-2,4.5-4.6,4.5h-52.5c-2.5,0-4.5-2-4.5-4.5v-94.6 c0-24.9-8.9-41.9-31.2-41.9c-17,0-27.1,11.5-31.6,22.5c-1.6,4-2,9.5-2,15v98.9c0,2.5-2,4.5-4.5,4.5h-52.5c-2.5,0-4.6-2-4.6-4.5 c0.1-25.2,0.7-147.4,0.1-176.1c-0.1-2.5,2-4.6,4.5-4.6h52.4c2.5,0,4.5,2,4.5,4.5v21.7c8.2-12.6,22.8-30.6,55.5-30.6 c40.5,0,70.9,26.5,70.9,83.3V395.8z M310.5,242v-0.6c-0.1,0.2-0.3,0.4-0.4,0.6H310.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.ccec6af1ec707e8b65a9652c722781a7.svg";
export { ForwardRef as ReactComponent };